import React from 'react'

import { PlainTextBlockEditSidebar } from '../plaintext/plaintext-block-edit-sidebar'

export const DescriptionBlockEditSidebar = function () {
  return <PlainTextBlockEditSidebar name="description" required={false} />
}
